module.exports = __webpack_public_path__ + "img/guided-tour.4b227693.svg";